(function () {
  function initScrollIndicator(indicator) {
    var target = document.getElementById(indicator.dataset.target);
    if (!target) return;

    var dots = [];

    function build() {
      indicator.innerHTML = '';
      dots = [];
      var pages = Math.ceil(target.scrollWidth / target.clientWidth);
      if (pages < 2) return;
      for (var i = 0; i < pages; i++) {
        var dot = document.createElement('span');
        dot.className = 'scroll-indicator__dot';
        dot.setAttribute('aria-hidden', 'true');
        indicator.appendChild(dot);
        dots.push(dot);
      }
      update();
    }

    function update() {
      if (!dots.length) return;
      var index = Math.round(target.scrollLeft / target.clientWidth);
      for (var i = 0; i < dots.length; i++) {
        dots[i].setAttribute('aria-current', String(i === index));
      }
    }

    target.addEventListener('scroll', update, { passive: true });
    new ResizeObserver(build).observe(target);
  }

  document.querySelectorAll('[data-scroll-indicator]').forEach(initScrollIndicator);
})();
